<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="35%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="120px"
      >
        <el-form-item
          label="考试章节"
          prop="examCourseChapterId"
        >
          <el-cascader
            v-model="createForm.examCourseChapterId"
            :options="chapter"
            :props="cascaderProps"
            placeholder="请选择考试章节"
          />
        </el-form-item>
        <!-- <el-form-item
          label="是否收录进视频考试"
        >
          {{ activeChapter.isIncludeVideoExam === 1?'是':'否' }}
        </el-form-item> -->
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'OrderVideoExamChapterDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, null],
      default: null,
    },
    examCourseId: {
      type: [Number, null],
      default: null,
    },
    examCourseChapterId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      title: '修改视频考试章节',
      createForm: {
        examCourseChapterId: this.examCourseChapterId,
        id: this.id,
      },
      cascaderProps: {
        value: 'id',
        label: 'chapterName',
        children: 'sonList',
        emitPath: false,
      },
      chapter: [],
      creatRules: {
        examCourseChapterId: [
          { required: true, message: '请选择章节', trigger: 'blur' },
        ],
      },
    };
  },
  // computed: {
  //   activeChapter() {
  //     let chapter = {};
  //     this.chapter.forEach(
  //       (item) => {
  //         item.sonList.forEach((son) => {
  //           if (son.id === this.createForm.examCourseChapterId) {
  //             chapter = son;
  //           }
  //         });
  //       },
  //     );
  //     return chapter;
  //   },
  // },
  watch: {
    examCourseChapterId(val) {
      if (val) {
        this.$nextTick(() => {
          this.createForm.id = this.id;
          this.createForm.examCourseChapterId = val;
        });
        this.getChapter();
      }
    },
    searchForm: {
      handler() {
        this.getHomePageStatistics();
      },
      deep: true,
    },
  },
  mounted() {
    // this.getChapter();
  },
  methods: {
    async getChapter() {
      if (this.examCourseId) {
        this.chapter = await axClient.course.listChapter(this.examCourseId);
      }
    },
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.order.updateVideoExamChapter(this.createForm);
          if (!data) return;
          this.$message.success('修改视频考试章节成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
